import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-agent-performance-metrics-saved-dashboard',
  templateUrl: './agent-performance-metrics-saved-dashboard.component.html',
  styleUrls: ['./agent-performance-metrics-saved-dashboard.component.scss']
})
export class AgentPerformanceMetricsSavedDashboardComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
